import { Container } from '@chakra-ui/react';
import { useVerifyShareLinkMutation } from '@client/graphql/__generated__/main-operations';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { ExpiredLinkCard } from '../../components/BuyerOfferAnalysis/BuyerView/ExpiredLinkCard';

interface SharedPageProps extends PropsWithChildren {
  resendLink: (token: string) => Promise<void>;
  isResendingLink: boolean;
}

export const SharedPage = ({
  children,
  resendLink,
  isResendingLink,
}: SharedPageProps) => {
  const { token } = useParams();
  const [isExpired, setIsExpired] = useState(false);
  const navigate = useNavigate();

  const [verifyShareLink, { loading }] = useVerifyShareLinkMutation({
    variables: {
      token: token || '',
    },
  });

  useEffect(() => {
    if (!token) {
      navigate('/');
    }

    void (async () => {
      const { data } = await verifyShareLink({});
      const verification = data?.verifyShareLink;

      if (!verification || !verification.isValid) {
        navigate('/404');
      }

      if (verification?.isExpired) {
        setIsExpired(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <CenterSpinner />;
  }

  if (isExpired) {
    return (
      <Container centerContent>
        <ExpiredLinkCard
          loading={isResendingLink}
          resendLink={resendLink}
          token={token || ''}
        />
      </Container>
    );
  }

  return <>{children}</>;
};
